<template>
    <div id="container">
    	<div class="floatC">
    		<div class="city-wrap-left">
    			<SafetySummary />
                <transition name="corona-fade" appear mode="out-in">
                    <keep-alive>
                        <component v-bind:is="covidSummaryComponent"
                                   :is-rolling="isCovidRolling"
                                   @change-rolling-click="toggleCovidRolling"
                                   @chart-activated="chartActivatedHandle"
                                   @chart-deactivated="chartDeactivatedHandle"/>
                    </keep-alive>
                </transition>
    		</div>
    		<div class="city-wrap-right">
    			<TrafficSummary />
    			<AirSummary />
    		</div>
    	</div>
        <WaterQaList />
    </div>
</template>

<script>
import { $WC } from '@/conf/common.const';
import SafetySummary from '@/views/realtime/SafetySummary.vue';
import AirSummary from '@/views/realtime/AirSummary.vue';
import TrafficSummary from '@/views/realtime/TrafficSummary.vue';
import CovidSummary from '@/views/realtime/CovidSummary.vue';
import CovidVaccinationSummary from '@/views/realtime/CovidVaccinationSummary.vue'
import WaterQaList from '@/views/realtime/WaterQaList.vue';

export default {
    name: 'realtime',
    data() {
        return {
            covidSummaryComponent: CovidSummary,
            covidSummaryInterval: undefined,
            isCovidRolling: true,
        }
    },
    created () {
        // 코로나 컴포넌트 변경
        this.covidSummaryIntervalStart();
    },
    methods: {
        covidSummaryIntervalStart() {
            this.covidSummaryInterval = setInterval(() => {
                if(this.covidSummaryComponent === CovidSummary) {
                    this.covidSummaryComponent = CovidVaccinationSummary;
                } else {
                    this.covidSummaryComponent = CovidSummary;
                }
            }, 1000 * 10);
        },
        chartActivatedHandle() {
            if(typeof this.covidSummaryInterval !== $WC.UNDEF) {
                clearInterval(this.covidSummaryInterval);
            }
        },
        chartDeactivatedHandle() {
            this.covidSummaryIntervalStart();
        },
        toggleCovidRolling() {
            if(this.isCovidRolling) {
                clearInterval(this.covidSummaryInterval);
            } else {
                this.covidSummaryIntervalStart();
            }
            this.isCovidRolling = !this.isCovidRolling;
        },
    },
    components: {
        SafetySummary,
        AirSummary,
        TrafficSummary,
        CovidSummary,
        CovidVaccinationSummary,
        WaterQaList,
    },
}
</script>

<style scoped>
.corona-fade-enter-active, .corona-fade-leave-active {
    transition: opacity .3s ease;
}
.corona-fade-enter, .corona-fade-leave-to {
    opacity: 0;
}
</style>
